import {AppState} from '../../interfaces/app-state.interface';
import {createSelector} from '@ngrx/store';
import {identity} from 'rxjs';


export class ZahlungsprotokollSelectors {

  private static select = {
    loading: (state: AppState) => state.zahlungsprotokollReducer?.loading,
    isDialogOpen: (state: AppState) => state.zahlungsprotokollReducer?.isDialogOpen,
    zahlungslaufId: (state: AppState) => state.zahlungsprotokollReducer?.zahlungslaufId,
    content: (state: AppState) => state.zahlungsprotokollReducer?.content,
    filename: (state: AppState) => state.zahlungsprotokollReducer?.filename,
  };

  public static loading = createSelector(
    this.select.loading,
    loading => !!loading,
  );

  public static isDialogOpen = createSelector(
    this.select.isDialogOpen,
    isDialogOpen => !!isDialogOpen,
  );

  public static zahlungslaufId = createSelector(
    this.select.zahlungslaufId,
    identity,
  );

  public static content = createSelector(
    this.select.content,
    identity,
  );

  public static filename = createSelector(
    this.select.filename,
    identity,
  );
}
